import React, { Component } from 'react';
import Nprogress from 'nprogress';
import ReactPlaceholder from 'react-placeholder';
import 'nprogress/nprogress.css';

import 'react-placeholder/lib/reactPlaceholder.css';
import CircularProgress from 'components/CircularProgress';

export default function asyncComponent(importComponent) {
  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null
      };
      // Since we're starting the progress bar in the constructor,
      // it will start as soon as the component is instantiated.
      Nprogress.start();
    }

    // Remove componentWillMount as it's deprecated.

    componentWillUnmount() {
      this.mounted = false;
      Nprogress.done(); // Ensure we stop the progress bar if the component is unmounted.
    }

    async componentDidMount() {
      this.mounted = true;
      try {
        const { default: Component } = await importComponent();
        if (this.mounted) {
          this.setState({
            component: <Component {...this.props} />
          });
        }
      } finally {
        // We should stop the progress bar regardless of whether the import succeeded or not.
        Nprogress.done();
      }
    }

    render() {
      const Component = this.state.component || <CircularProgress />;
      return (
        <ReactPlaceholder type="text" rows={7} ready={Component !== null}>
          {Component}
        </ReactPlaceholder>
      );
    }
  }

  return AsyncFunc;
}
